export default __webpack_public_path__ + "static/media/MaalOgOensker.255cb119.svg";